import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { AllIcons } from 'helpers/allIcons'
import { usePendingNotificationsStore } from 'store/pendingNotificationsStore'

import styles from './BellLink.module.scss'

const BellLink = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const notificationsCount = usePendingNotificationsStore(s => s.notifications)
  const setNotifications = usePendingNotificationsStore(s => s.resetNotifications)

  const isActive = [
    '/notifications',
    '/notifications/fans',
    '/notifications/site',
  ].includes(location.pathname)

  useEffect(() => {
    if (isActive && notificationsCount > 0) {
      setNotifications()
    }
  }, [isActive, notificationsCount, setNotifications])

  const badgeText =
    typeof notificationsCount === 'number' && notificationsCount > 99
      ? '99+'
      : notificationsCount

  return (
    <Link
      className={styles.bell}
      to="/notifications"
      aria-label={t('notifications')}
      title={t('notifications')}
    >
      <img
        src={isActive ? AllIcons.footer_notifications_active : AllIcons.footer_notifications}
        alt={t('notifications')}
      />
      {notificationsCount > 0 && (
        <div className={styles.bell_count} aria-live="polite">
          {badgeText}
        </div>
      )}
    </Link>
  )
}

export default BellLink
